import React, { useState, useEffect } from "react";
import { Configs } from "../../common/config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useForm } from "react-hook-form";

//--- Material Control
import {
  Button,
  TextField,
  IconButton,
  Tooltip,
  Popover,
  Fab,
} from "@material-ui/core";

//--- Material Icon
import AddCircle from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import FilterListIcon from "@material-ui/icons/FilterList";
import SearchIcon from "@material-ui/icons/Search";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import RefreshIcon from '@material-ui/icons/Refresh';

import DeleteDialog from "../../components/dialog-delete/dialog-delete.view";

//--- Notifications
import ShowNotification from "../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../utils/configuration";
import * as viVN from "../../language/vi-VN.json";

//--- Redux store
import * as categoryAction from "../../redux/store/planning-category-management/planning-category.store";
import ListCategoryManagement from "./list-category-management/list-category-management.view";
import EditCategoryManagement from "./edit-category-management/edit-category-management.view";
import AddCategoryManagement from "./add-category-management/add-category-management.view";
import * as appActions from "../../core/app.store";

function CategoryManagement(props) {
  const { showLoading } = props;
  const [categoryModels, setCategoryModels] = useState();
  const [totalItemCount, setTotalItemCount] = useState();
    const [keyword, setKeyword] = useState();
    const [governmentId, setGovernmentId] = useState();
    const [provinceId, setProvinceId] = useState();
    const [categoryFieldId, setCategoryFieldId] = useState();
    const [categoryTypeId, setCategoryTypeId] = useState();
    const [categoryStatusId, setCategoryStatusId] = useState();
    const [isActive, setIsActive] = useState();
  const [categoryId, setCategoryId] = useState();
  const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("Code");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(Configs.DefaultPageSize);
  const [status, setStatus] = useState();

  const { register, handleSubmit } = useForm({ mode: "all", reValidateMode: "onBlur" });

  useEffect(() => {
    GetListCategory();
  }, [])

  //const GetListCategory = (pageIndex = 1, pageSize, sortExpression = orderBy + " " + order) => {
    const GetListCategory = () => {
    showLoading(true);
    //setPage(pageIndex - 1);
        setPage(1);
      categoryAction.GetListAll()
          .then(res => {
      if (res && res.content) {
          setCategoryModels(res.content);
          setTotalItemCount(res.content.length);
        //setTotalItemCount(res.content.totalItemCount);
              }
      else
          setCategoryModels([]);
              showLoading(false);
    }).catch(err => {
      showLoading(false);
    });
  }

  //--- Dialog
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  const handleOpenEditDialog = (categoryId) => {
    setCategoryId(categoryId);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    GetListCategory();
    setOpenEditDialog(false);
  };

  const handleOpenDeleteDialog = (categoryId, status) => {
    setCategoryId(categoryId);
    setStatus(status);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleOpenRestPasswordDialog = (categoryId) => {
    setCategoryId(categoryId);
  };

  //--- Filter
  const [filterSection, setFilterSection] = useState(null);

  const handleClickFilter = (event) => {
    setFilterSection(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setFilterSection(null);
  };

  const ShowNotificationError = (messages) => {
    ShowNotification(messages, NotificationMessageType.Error)
  }

  const openFilter = Boolean(filterSection);
  const idFilter = openFilter ? 'popoverSlider' : undefined;

  const handleClearAllField = () => {
    setKeyword("");
    document.getElementById("formSearch").reset();
  }

  const onSubmit = async (data) => {
    await GetListCategory(1, rowsPerPage, orderBy + " " + order);
    handleCloseFilter()
  }

  const refresh = () => {
      setKeyword("");
    setOrderBy("Code")
    setOrder("asc");
    GetListCategory(1, rowsPerPage);
  }

  const handleDelete = () => {
    categoryAction.Delete(categoryId).then(
      (res) => {
        if (res && res.content && res.content.status) {
          GetListCategory(1, rowsPerPage, orderBy ? (orderBy + " " + order) : "");
          handleCloseDeleteDialog();
          ShowNotification(
            viVN.Success.DeleteCategory,
            NotificationMessageType.Success
          );
        }
      },
      (err) => {
        err &&
          err.errorType &&
          ShowNotification(
            viVN.Errors[err.errorType],
            NotificationMessageType.Error
          );
      }
    );
  };


  return (
    <div className="slider">
      <div className="d-sm-flex align-items-center justify-content-between mb-3">
        <h1 className="h3 mb-0 text-gray-800">
          Quản lý loại QH
          <Tooltip title="Tìm kiếm">
            <Fab
              color="primary"
              aria-label="filter"
              size="small"
              className="ml-2"
              aria-describedby={idFilter}
              onClick={handleClickFilter}
            >
              <FilterListIcon />
            </Fab>
          </Tooltip>
          <Tooltip title="Refresh">
            <Fab color="primary" aria-label="filter" size="small" onClick={refresh} className="ml-2">
              <RefreshIcon />
            </Fab>
          </Tooltip>
          <Popover
            id={idFilter}
            open={openFilter}
            anchorEl={filterSection}
            onClose={handleCloseFilter}
            style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <div className="p-3" style={{ width: '30rem' }}>
              <div className="text-right border-bottom mb-3 pb-2">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleCloseFilter}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
              <form id="formSearch" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label className="text-dark">Từ khóa</label>
                  <TextField className="w-100" name="keyword" value={keyword} onChange={(e) => { setKeyword(e.target.value) }} inputRef={register} />
                </div>
                <div className="border-top">
                  <div className="row">
                    <div className="col-12 text-right mt-3">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}
                      >
                        <SearchIcon fontSize="small" /> Tìm kiếm
                      </Button>
                      <Button variant="contained" className="ml-2" onClick={handleClearAllField}>
                        <ClearAllIcon fontSize="small" /> Bỏ lọc
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Popover>
        </h1>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenAddDialog}
          startIcon={<AddCircle />}
        >
          Thêm dự án
        </Button>
      </div>
      {categoryModels ? <ListCategoryManagement
        totalItemCount={totalItemCount}
        categoryModels={categoryModels}
        GetListCategory={GetListCategory}
        editAction={handleOpenEditDialog}
        deleteAction={handleOpenDeleteDialog}
        setOrder={setOrder} setOrderBy={setOrderBy}
        setPage={setPage} setRowsPerPage={setRowsPerPage}
        order={order} orderBy={orderBy}
        page={page} rowsPerPage={rowsPerPage}
        restAction={handleOpenRestPasswordDialog}
      /> : ""}
      {openAddDialog && (
        <AddCategoryManagement
          isOpen={openAddDialog}
          onClose={handleCloseAddDialog}
          onSuccess={handleCloseAddDialog}
          ShowNotificationError={ShowNotificationError}
          GetListCategory={GetListCategory}
          rowsPerPage={rowsPerPage}
          setOrder={setOrder}
          setOrderBy={setOrderBy}
          showLoading={showLoading}
        />
      )}

      {openEditDialog && (
        <EditCategoryManagement
          isOpen={openEditDialog}
          onClose={handleCloseEditDialog}
          onSuccess={handleCloseEditDialog}
          categoryId={categoryId}
          ShowNotificationError={ShowNotificationError}
          GetListCategory={GetListCategory}
          rowsPerPage={rowsPerPage}
          setOrder={setOrder}
          setOrderBy={setOrderBy}
          showLoading={showLoading}
        />
      )}
      {openDeleteDialog ? (
        <DeleteDialog
          isOpen={openDeleteDialog}
          rowsPerPageCommon={rowsPerPage}
          onClose={handleCloseDeleteDialog}
          onSuccess={handleDelete}
        />
      ) : (
          ""
        )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  isLoading: state.app.loading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoading: appActions.ShowLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CategoryManagement);
